<!--
 * @Author: Merlin
 * @Date: 2025-02-11 17:46:09
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 17:11:14
 * @Description: 

-->
<template>
	<NuxtLayout name="casino">
		<div class='limbo-game q-px-md'>
			<div class="limbo-container">
				<div class="limbo-article">
					<div class="limbo-section">
						<div class="limbo-row">
							<!-- 顶部菜单 start -->
							<ClientOnly fallback-tag="span">
								<GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
									<GameSettingsButtonLiveChat v-if="userStore.isLoggedIn" v-model="isOpenLiveChat" />
									<GameSettingsButtonAnimate v-model="settingStore.animation" />
									<GameSettingsButtonFast v-model="settingStore.game.limbo.fast" />
									<GameSettingsButtonFairness v-model="isOpenFairness" />
									<GameSettingsButtonRule v-model="isOpenRule" name="limbo" />
									<GameSettingsButtonVocie 
										v-model="settingStore.inhouseGames.sound.on" 
										v-model:voice-model-value="settingStore.inhouseGames.sound.music" 
										:saveAfterChange="true"
									/>
								</GameSettingsDiceTabsWrapper>
							</ClientOnly>
							<!-- 顶部菜单 end -->
						</div>
						<!-- 
							↓ 游戏舞台 
						-->
						<div class="limbo-row">
							<!-- 展示区 -->
							<ClientOnly>
								<div class="full-width limbo-bg h-fit relative-position">
									<!-- 历史开奖记录 start -->
									<HistoryResult />
									<!-- 历史开奖记录 end -->
									<!-- 游戏动画区域 -->
									<canvas 
										id="space" 
										width="1000" 
										height="737"
									/>
									<div class="relative-position hidden">
										<img src="@/assets/webp/limbo/up.webp" ref="up" class="full-height full-width" />
										<img src="@/assets/webp/ships.webp" ref="ships" class="full-height full-width"/>
										<img src="@/assets/webp/limbo/expl.webp" ref="expl" class="full-height full-width"/>
										<img src="@/assets/webp/limbo/fires.webp" ref="fires" class="full-height full-width"/>
									</div>
									<!-- 倍数展示 start -->
									<div class="limbo-status" v-if="showMulti">
										<p 
											class="limbo-coeficient"
											:class="[
												limitStatusAnimate ? 'coef-animation' : '',
												multiColor,
												!settingStore.game.limbo.fast ? 'multi-animation' : 'multi-animation-fast'
											]"
										>
											{{ limboCoeficient }}x
										</p>
									</div>
									<!-- 倍数展示 end -->
									<p class="over-limit-tips"
										v-if="sOverLimitPayout"
									>
										{{ sOverLimitPayout }}
									</p>
								</div>
							</ClientOnly>
							<!-- 
								↑ 游戏舞台 
								↓ 用户设定区（表单） 
							-->
							<!-- 投注选项区域 start -->
							<ClientOnly>
								<div class="mt-[20px]">
									<BetOptions 
										v-if="autoBetToolKit || betTookit"
										:betTookit="betTookit && betTookit" 
										:auto-bet-tool-kit="autoBetToolKit && autoBetToolKit"
										v-model:bet-amount-modal-value="oForm.amount" 
										v-model:is-submiting="oForm.isSubmiting"
										:sound="settingStore.sound" 
										:is-auto="gameStore?.limbo.auto.default" 
										:bet-submit="betSubmit"
										v-model:bet-target-model-value="oForm.betTargetNumber"
										@change-mode="toChangeMode"
									/>
								</div>
							</ClientOnly>
							<!-- 投注选项区域 end -->
							<ClientOnly>
								<!-- 自动 -->
								<div class="q-mt-md game-container">
									<CasinoAutoSection 
										:ref="el => autoDialog = el"
                                        v-model:amount="oForm.amount"
										:is-fast="gameStore.limbo.fast" 
										:is-submiting="oForm.isSubmiting"
										:is-auto="gameStore.limbo.auto.default" 
									/>
								</div>
							</ClientOnly>
						</div>
					</div>
				</div>
				<div class="limbo-aside">
					<!-- 底部留白 -->
				</div>
			</div>
		</div>
	</NuxtLayout>
	
</template>
<script>
import { defineComponent } from 'vue'
// stores
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useLimboStore } from '@/stores/cansino/limbo';
// socket
import { useGameSocket } from '@/socket/game';
// components
import BetOptions from './_components/betOptions';
import HistoryResult from './_components/historyResult/index.vue';
// functions
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import { Space, SpriteMovie } from './js/stars';
import { accMultiple, accSub, accAdd } from "@/pages/casino/plinkoGame/js/module.js";
// mp3
import limboBGM from '@/assets/mp3/game_general_bgm.mp3';
import limboFly from '@/assets/mp3/limbo/limbo_fly.mp3';
import limboLosing from '@/assets/mp3/limbo/losing.mp3';
import limboWin from '@/assets/mp3/limbo/limbo_win.mp3';
import { showTips4BadAmountIfNeeded} from '@/common/js/betHelper';

export default defineComponent({
	name: 'limboGame',
	components: {
		BetOptions,
		HistoryResult,
	},
	data() {
		return {
			isFast: false,
			startFast: false,
			randomNum: '',
			// 历史下注结果
			randomNumHistory: [],
			betNum: 2,
			limboStart: 0,
			limboStartScale: 1,
			isOpenLiveChat: false, // 右侧统计
            isOpenFairness: false, // 公平性弹框
            isOpenRule: false, // 规则弹框
			settingStore: useSettingsStore(),
			gameStore: useSettingsStore().game,
			userStore: useUserStore(),
            joinStore: useJoinStateStore(),
			gameHistoryStore: useGameHistoryStore(),
			limboStore: useLimboStore(),
			betTookit: null,
			autoBetToolKit: null,
			oForm: {
                amount: 0,
                isSubmiting: false,
				betTargetNumber: 2
            },
			imgs: ['up', 'ships', 'expl', 'fires'],
			shipsData: {
                move: { x: 0, y: 0, w: 65 * 2, h: 131 * 2 },
                stop: { x: 68 * 2, y: 0, w: 68 * 2, h: 131 * 2 },
                scale: 1,
                y: 660
            },
			space: null, // 图片绘制区域
			live: false, // 是否在当前游戏页面
			isLocked: false, // 火箭的状态 true-起飞 false-初始位置
			drawExpl: null, // 火箭尾部烟圈
			loadCounter: 0,
			fire: null, // 火箭尾部火焰
			soundOption: { // 音效配置
				bg: {
					src: limboBGM,
					loop: true,
					isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
				},
                limboFly: {
                    src: limboFly,
                },
                limboWin: {
                    src: limboWin
                },
                limboLosing: {
                    src: limboLosing
                }
            },
			howlerTimer: null,
			historyTimer: null,
			currentBetResult: {}, // 当前下注结果
			limboCoeficient: 1.00, // 倍数
			musicControler: null,
			canvas: null,
			showTimeAni: false,
			autoDialog: null,
			multiColor: 'text-white', //  倍数颜色
		};
	},
	computed: {
		limitStatusAnimate(){
			return this.showTimeAni && this.currentBetResult.winAmount > 0 && this.settingStore.animation && !this.settingStore.game.limbo.fast;
		},
		showMulti(){
			return this.gameHistoryStore.gameHistoryDelay.response?.length
		},
		// ↓ 如果返现金额超过上限值，提示用户 
		sOverLimitPayout(){
			const maxWin = this.joinStore.betttingLimits.maxWin;
			const product = (
				this.oForm.amount * 
				this.oForm.betTargetNumber
			);
			 // ↓ 调取 查询当前游戏当前币种最大赔付金额
			showTips4BadAmountIfNeeded(product)
			// const bResult = product  > maxWin;
			// if (!bResult) return ''; // 没超，返回 
			// const s1 = product.toLocaleString();
			// const s2 = maxWin.toLocaleString();
			// console.log(`超限监测：${s1} > ${s2}, 已经超限`);
			// const { t: $tFn } = useNuxtApp().$i18n;
			// const sCurrency = (this.settingStore.pickedCurrency || '').toUpperCase();
			// return $tFn('commonInfo.payoutOverLimit', {
			// 	limit: `${s2} ${sCurrency}`,
			// });
		},
	},
	watch: {
		// 监听音效开关 是否播放背景音乐
        'settingStore.inhouseGames.sound.on': {
            handler(newVal){
                if (newVal && !this.musicControler){
                    // 音效初始化
					this.musicControler = new MusicControler(this.soundOption);
                }
            },
            immediate: true,
        },
		'settingStore.animation': {
			handler(newVal){
				if (newVal){
					window.requestAnimationFrame(this.update);
				}
			},
			// immediate: true,
            deep: true
		},
		isLocked(val) {
            if (val) {
                this.shipsData.y = 660;
				if (this.drawExpl) this.drawExpl.isAnimate = true;
            } else {
                this.shipsData.y = 800;
            }
            this.shipsData.scale = 1;
        },
		'gameStore?.limbo.auto.default': {
			handler(newVal){
				if (newVal){
					this.joinStore.gameRunning = true;
				} else {
					this.joinStore.gameRunning = false;
				}
			},
			immediate: true
		}
	},
	mounted() {
		this.live = true;
		this.$nextTick(() => {
			this.canvasInit();
		})

		this.oForm = {
            amount: 0,
            isSubmiting: false,
			betTargetNumber: 2
        }

		this.betTookit = useBettingToolkit(this.oForm);
		this.autoBetToolKit = useAutoBetToolKit(this.oForm, this.betSubmit);

		this.getHistory()
		onUnmounted(() => {
			this.howlerTimer && clearTimeout(this.howlerTimer);
			this.historyTimer && clearTimeout(this.historyTimer);
			this.musicControler?.toDestory();
			this.live = false;
		})
	},
	methods: {
		/**
         * 获取历史下注结果
         */
		getHistory() {
            this.historyTimer = setTimeout(() => {
                const { gameHistoryDelay } = useGameHistoryStore();
				// console.log(gameHistoryDelay, 'gameHistoryDelay')
				if (gameHistoryDelay.response.length){
					// this.randomNumHistory = gameHistoryDelay.response;
					this.currentBetResult = gameHistoryDelay.response[0]
					this.limboCoeficient = Number(gameHistoryDelay.response[0].roll_number);
					this.multiColor = this.currentBetResult.winAmount > 0 ? 'text-[#3ecc7f]' : 'text-[#e04461]';
				}
            }, 300)
        },
		/**
		 * 添加过渡动画，从开始值startValue -> 要显示的值endValue
		 * @param {number} startValue 开始值
		 * @param {number} endValue 要显示的值
		 * @param {number} duration 时间/毫秒
		 */
		setResultAnimation(startValue, endValue, duration = 400, ts) {
			let startTime = null;
			const func = async (timeStamp) => {
				if (!startTime){
					startTime = timeStamp;
				}
				const step = accSub(timeStamp, startTime) / duration;
				
				const firstValue = Math.floor(accMultiple(step, endValue) * 100) / 100;
				this.limboCoeficient = Math.min(
					accAdd(firstValue, startValue),
					endValue,
				);
				// 动画完成时，赔率颜色同步变化
				if (step > 0.4 && step < 1){
					this.multiColor = this.currentBetResult.winAmount > 0 ? 'text-[#3ecc7f]' : 'text-[#e04461]';
				} 
				if (step < 1) {
					window.requestAnimationFrame(func);
				} else { // 动画执行完毕
					// 防止出现跟最后结果不一致的情况
					this.limboCoeficient = endValue;
					this.joinStore.showDateInQueue(); // 插入游戏结果并播放动画
					this.userStore.queueForward(ts); // 显示余额变化
					this.showTimeAni = true;
					setTimeout(() => {
						this.showTimeAni = false;
					}, 100)
				}
			}
			window.requestAnimationFrame(func);
		},
		/**
		 * 下注
		 */
		async betSubmit() {
			const { currencies, currentCurrency } = this.userStore;
            if (!currencies[currentCurrency].balance){
                return;
            }
			this.joinStore.gameRunning = true;
			this.currentBetResult = {};
			const { EMIT_LIMBO_BET } = useGameSocket();
			let params = {
				amount: this.oForm.amount.beFixed(2),
				frontID: new Date().getTime(),
				isFast: this.isFast,
				prediction: this.oForm.betTargetNumber,
			}
			const isAuto = Boolean(this.gameStore?.limbo.auto.default);
			// if (import.meta.env.DEV_MODE && Math.random() <= 0.3){ 
            //     params.amount = 0; 
            // }
			try{
				const ts = this.userStore.queueStart(); // 防止余额立即变化
				// 快速模式下，直接发送请求，没有动画效果及各种音效
				if (this.gameStore?.limbo.fast){
					const res = await EMIT_LIMBO_BET(params);
					
					console.log(res, 'EMIT_LIMBO_BET-fast')
					// 下注失败
					if (!res || res.error || res.code){
						this.userStore.queueDelete(ts);
						isAuto || showNegativeNotify(res?.error);
						this.joinStore.gameRunning = false;
						return res;
					} else {
						this.multiColor = res.winAmount > 0 ? 'text-[#3ecc7f]' : 'text-[#e04461]';
						this.currentBetResult = res;
						await Sleep(300);
						this.limboCoeficient = Number(res.roll_number);
						this.joinStore.showDateInQueue(); // 插入游戏结果并播放动画
						this.userStore.queueForward(ts); // 显示余额变化
						if (!isAuto){
							this.joinStore.gameRunning = false;
						}
						
						return {
							winAmount: res.winAmount,
							amount: this.oForm.amount.beFixed(2)
						};
					}
					
				} else {					
					// const prevResult = this.limboCoeficient;
					// 火箭发射
					const res = await EMIT_LIMBO_BET(params);
					// 下注失败
					if (!res || res.error || res.code){
						this.userStore.queueDelete(ts);
						isAuto || showNegativeNotify(res?.error);
						this.joinStore.gameRunning = false;
						return res; 
					} else {
						this.howlerTimer && clearTimeout(this.howlerTimer);
						// 播放飞行音效
						this.howlerTimer = setTimeout(() => {
							this.musicControler?.oAudio.limboFly.toPlay();
						}, 300)
						this.currentBetResult = res;
						this.isLocked = true;
						// this.multiColor = 'text-white';
						setTimeout(() => {
							this.setResultAnimation(0, Number(res.roll_number), 400, ts)
						}, 200)
						await Sleep(500);
						// 火箭回到初始位置
						this.isLocked = false;
						// 播放lose音乐
						if (Number(res.roll_number) < this.oForm.betTargetNumber){
							this.musicControler?.oAudio.limboLosing.toPlay();
						} else { // 播放win音乐
							this.musicControler?.oAudio.limboWin.toPlay();
						}
						await Sleep(300);
						if (!isAuto){
							this.joinStore.gameRunning = false;
						}
						return {
							winAmount: res.winAmount,
							amount: this.oForm.amount.beFixed(2)
						};
					}
					
				}
			}catch(error){
				this.userStore.queueDelete(ts);
				console.log(error, 'limboGame-error');
				this.joinStore.gameRunning = false;
			}
		},
		/**
		 * 绘制火箭尾部烟圈
		 * @param {*} canvas canvas实例
		 */
		initExpl(canvas){
			this.drawExpl = new SpriteMovie(
				13,
				1,
				this.$refs["expl"],
				() => {
					this.drawExpl.isAnimate = false;
				},
				canvas
			);
			this.drawExpl.x = 500;
			this.drawExpl.y = 660;
		},
		/**
		 * 绘制火箭尾部火焰
		 * @param {*} canvas canvas实例
		 */
		initRocketFires(canvas){
			this.fire = new SpriteMovie(
				10,
				1,
				this.$refs["fires"], 
				() => {}, 
				canvas
			);
			this.fire.x = 504;
			this.fire.y = 660;
			this.fire.isAnimate = true;
		},
		/**
		 * 初始化画布，绘制火箭尾部火焰和烟圈
		 */
		async canvasInit(){
			await Sleep(500);
			this.imgs.forEach(() => {
				if (++this.loadCounter === this.imgs.length) {
					let canvas = document.querySelector('canvas');
					if (canvas){
						this.canvas = canvas;
						this.space = new Space(canvas);
						
						this.initExpl(canvas)
						this.initRocketFires(canvas);
						this.update();
					}
				}
			});
		},
		/**
		 * 绘制星星和火箭发射效果
		 * 如果开启动画 则为星星添加动画效果并且显示火箭
		 */
		update() {
            const { space, $refs, shipsData } = this;
            if (!this.live) {
                return;
            }
			// 绘制星星
            space.drawStars();
			// 星星运动
            space.moveStars();
            space.drawImage($refs["up"]);
            if (this.settingStore.animation) {
                if (!this.settingStore.game.limbo.fast) {
                    let name = "stop";
                    if (this.isLocked) {
                        name = "move";
                        shipsData.y -= 8;
                        shipsData.scale -= 0.025;
                        if (shipsData.scale < 0) {
                            shipsData.scale = 0;
                        }
                    } else if (shipsData.y > 660) {
                        shipsData.y -= 10;
                    }
                    space.drawAtlas(
                        $refs["ships"],
                        shipsData[name],
                        500,
                        shipsData.y,
                        shipsData.scale
                    );
                    if (!this.isLocked) {
                        this.fire.y = shipsData.y + 34;
                        this.fire.update();
                    }
                    this.drawExpl.update();
                }
                window.requestAnimationFrame(this.update);
            }
        },
		// ↓ 自动模式输入面板“窗口化改造” 添加的变量与方法：  
        toChangeMode(isAuto) { 
            // ↓按各个游戏的实际情况设定 
            this.settingStore.game.limbo.auto.default = !!isAuto;
            if (isAuto){
                this.autoDialog.switchAutoDialogVisible(true);
            }
        }
	}
})
</script>

<style lang='scss' scoped>
.limbo-game {
	line-height: normal;
	padding: 0;
	width: 100%;
	user-select: none;

	.limbo-container {
		margin: 0 auto;
		max-width: 1088px;
		position: relative;
		width: 100%;

		.limbo-article {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.limbo-section {
				flex: auto;
				max-width: 650px;
				width: 100%;
				margin: 0 auto;

				.limbo-row {
					.button-operation {
						width: 100%;
						max-width: 650px;
						margin: 0 auto;

						.button-settings {
							cursor: pointer;
							display: flex;
							justify-content: flex-end;
							margin-bottom: 12px;
							margin-top: 2px;
							width: 100%;

							&>:deep(div) {
								flex: none;

								&:not(:last-child) {
									margin-right: 5px;
								}
							}
						}

						@media (max-width: 1000px) {
							.button-settings {
								justify-content: flex-start;

								&>:deep(div) {
									flex: 1;
								}
							}
						}
					}

					
					#space {
						display: block;
						height: auto;
						-webkit-user-select: none;
						-moz-user-select: none;
						user-select: none;
						width: 100%;
						border-radius: 10px;
					}
					.limbo-status {
						align-items: center;
						display: flex;
						flex-direction: column;
						left: 50%;
						pointer-events: none;
						position: absolute;
						top: 50%;
						transform: translate(-50%,-30px);
						.limbo-coeficient {
							font-size: 60px;
							font-weight: 900;
							line-height: 1;
							transform: scale(1);
							white-space: nowrap;
							
							width: 150px;
							text-align: center;
						}

						.coef-animation {
							animation: animaScale .1s ease-out;
							animation-fill-mode: forwards;
						}
					}

					.game-container {
						@media (max-width: 1100px) {
							margin-bottom: 0;
							margin-top: 0;
						}
						@media (max-width: 576px) {
							flex-direction: column;
							align-items: center;
							:deep(.RTP-body) {
								align-items: center;
								margin-top: 16px;
								position: relative;
							}
						}
					}
				}

				@media (max-width: 768px) {
					.limbo-row {
						&:nth-of-type(2){
							margin-top:38px
						}
					}
				}
			}
		}
	}
	.limbo-bg  {
		background-image: url("assets/svg/limboBg.svg");
		background-position: 50%;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 10px;
		position: relative;
	}
}

.over-limit-tips{
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 0 15px 16px;
	text-align: center;
	color: white; 
	font-size: 14px; 
	text-shadow: 1px 1px 0px rgb(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
	.limbo-game {
		padding: 2px 4px;
	}
}
.multi-animation {
	transition-property: scale, color;
	transition-duration: .1s, .3s;
	transition-timing-function: ease-out, ease-out;
	transition-delay: .3s, 0s;
}
.multi-animation-fast {
	transition: all .1s .3s;
}
@keyframes animaScale {
    0% {
        transform: scale(1)
    }

    50% {
        transform: scale(1.2)
    }

    to {
        transform: scale(1)
    }
}
</style>